import { isNil } from "lodash-es"

export class PatchBuilder<T> {
  private readonly patch: Partial<T> = {}

  string<K extends keyof T>(
    key: K,
    value: Extract<T[K], string> | undefined
  ): this {
    if (value === undefined || value === "") {
      return this
    }

    this.patch[key] = value
    return this
  }

  number<K extends keyof T>(
    key: K,
    value: Extract<T[K], number> | undefined
  ): this {
    if (value === undefined || isNaN(value)) {
      return this
    }

    this.patch[key] = value
    return this
  }

  boolean<K extends keyof T>(
    key: K,
    value: Extract<T[K], boolean> | undefined
  ): this {
    if (value === undefined) {
      return this
    }

    this.patch[key] = value
    return this
  }

  date<K extends keyof T>(
    key: K,
    value: Extract<T[K], Date> | null | undefined
  ): this {
    if (isNil(value) || isNaN(value.getTime())) {
      return this
    }

    this.patch[key] = value
    return this
  }

  build(): Partial<T> {
    return { ...this.patch }
  }
}
